import React, { useEffect, useState } from "react";
import { db, auth } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import Layout from "../components/layout/Layout";
import { useNavigate } from "react-router-dom";
import BackHomeButton from "../components/BackHomeButton";

import { doc, getDoc } from "firebase/firestore";

function Worksheet_Quiz_Shared_With_Me() {
  const [worksheets, setWorksheets] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [profileExists, setProfileExists] = useState(false);
  const [userName, setUserName] = useState("");
  const [persona, setPersona] = useState("");

useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged(async (user) => {
    if (!user) {
      navigate("/login");
      return;
    }

    try {
      // 1️⃣ Fetch Profile
      const profileRef = doc(db, "profiles", user.uid);
      const profileSnap = await getDoc(profileRef);

      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setProfileExists(true);
        setUserName(profileData.name);
        setPersona(profileData.persona);
      }

      // 2️⃣ Fetch Shared Worksheets
const q = query(
  collection(db, "Shared_Worksheets"),
  where("friendEmail", "==", user.email)
);

const snapshot = await getDocs(q);

// ✅ Deduplicate by worksheetId + sharedByEmail
const uniqueMap = new Map();

snapshot.docs.forEach(docSnap => {
  const data = docSnap.data();

  const uniqueKey = `${data.worksheetId}_${data.sharedByEmail}`;

  // Keep latest version (overwrite if exists)
  uniqueMap.set(uniqueKey, {
    id: docSnap.id,
    ...data
  });
});

const uniqueWorksheets = Array.from(uniqueMap.values());

setWorksheets(uniqueWorksheets);
setLoading(false);

    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  });

  return () => unsubscribe();
}, []);

  return (



      <div className="max-w-6xl mx-auto px-4 py-8">

        <BackHomeButton/>

        <h1 className="text-2xl font-bold mb-6 text-gray-800">
          📚 Shared Worksheets
        </h1>

        {loading && (
          <p className="text-gray-500">Loading worksheets...</p>
        )}

        {!loading && worksheets.length === 0 && (
          <p className="text-gray-500">
            No worksheets shared with you yet.
          </p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

{worksheets.map((item) => (
  <div
    key={item.id}
    className="bg-white rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden border border-gray-100"
  >
    {/* PDF Preview */}
    <div className="h-56 bg-gray-100">
      <iframe
        src={`${item.fileUrl}#toolbar=0`}
        title="PDF Preview"
        className="w-full h-full"
      />
    </div>

    <div className="p-4 space-y-2">

       <h3 className="font-semibold text-gray-800 text-base break-all leading-snug">
        {item.fileName}
       </h3>

      <p className="text-sm text-gray-500">
        📘 Subject: {item.subject}
      </p>

      <p className="text-sm text-gray-500">
        🎓 Standard: {item.standard}
      </p>

      <p className="text-sm text-gray-500">
        🏫 School: {item.school}
      </p>

      <p className="text-xs text-gray-400">
        👤 Shared by: {item.friendName}
      </p>

      <p className="text-xs text-gray-400">
        💬 Message: {item.message}
      </p>

      <div className="flex justify-between items-center mt-3">

        <button
          onClick={() => window.open(item.fileUrl, "_blank")}
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded-xl hover:bg-blue-700 transition"
        >
          View & Download
        </button>

      </div>
    </div>
  </div>
))}

        </div>
      </div>
   
  );
}

export default Worksheet_Quiz_Shared_With_Me;